import { STTypeEnum } from 'data/scheduledTransactions/scheduledTransactionsTypes';
import { CoaTypeEnum } from 'data/chartOfAccounts/types';
import { getBalanceAdjustmentString } from 'data/chartOfAccounts/utils';

export function coaIncludedInList(coa, categoriesById, accountsById, stType) {
  switch (coa.type) {
    case CoaTypeEnum.CATEGORY: {
      const category = categoriesById.get(coa.id);
      if (category && category.isExcludedFromCategoryList) {
        return false;
      }
      break;
    }

    case CoaTypeEnum.BALANCE_ADJUSTMENT: {
      if (
        stType === STTypeEnum.TRANSFER &&
        getBalanceAdjustmentString(coa.id) !== 'Transfer'
      ) {
        return false;
      }
      break;
    }

    case CoaTypeEnum.UNCATEGORIZED: {
      if (stType === STTypeEnum.INCOME) {
        return false;
      }
      break;
    }

    case CoaTypeEnum.ACCOUNT: {
      const account = accountsById.get(coa.id);
      if (account && account.type === 'INVESTMENT') {
        return false;
      }
      break;
    }

    default:
      break;
  }
  return true;
}
